(() => {
  const root = document.querySelector('[data-db-root]');
  if (!root) return;
  const selects = [...document.querySelectorAll('[data-db-select]')];
  const buttons = [...document.querySelectorAll('[data-db-add]')];
  const statuses = [...document.querySelectorAll('[data-db-status]')];
  const selectVariant = (id) => { root.dataset.variantId = id; selects.forEach((select) => { select.value = id; }); const option = selects[0]?.selectedOptions[0]; const available = option?.dataset.available === 'true'; buttons.forEach((button) => { button.disabled = !available; }); };
  selects.forEach((select) => select.addEventListener('change', () => selectVariant(select.value)));

  const featureContent = {
    toe: ['01 · Reinforced toe', 'Made for the bumps that come with real work.', 'Extra structure at the toe helps guard against everyday impact and abrasion without turning the boot into something stiff or cumbersome.'],
    collar: ['02 · Breathable lining', 'Comfort that keeps moving with you.', 'A flexible neoprene collar makes ankle movement easy, while the breathable lining helps air circulate when the pace or temperature rises.'],
    heel: ['03 · Reinforced heel', 'Protection behind every step.', 'A reinforced heel stands up to impact and abrasion. The molded heel kick also gives you a hands-free way out at the end of the day.'],
    sole: ['04 · Cushioned insole', 'A softer landing on hard ground.', 'The molded comfort insole adds cushioning underfoot for longer stretches on concrete, timber, and other unforgiving surfaces.']
  };
  const featureBox = document.querySelector('[data-db-feature-tooltip]');
  const featureClose = document.querySelector('[data-db-feature-close]');
  document.querySelectorAll('[data-db-feature]').forEach((hotspot) => hotspot.addEventListener('click', () => {
    document.querySelectorAll('[data-db-feature]').forEach((item) => item.classList.toggle('is-active', item === hotspot));
    const copy = featureContent[hotspot.dataset.dbFeature];
    if (featureBox && copy) {
      featureBox.className = `db-feature-tooltip db-feature-tooltip--${hotspot.dataset.dbFeature} is-visible`;
      featureBox.querySelector('span').textContent = copy[0];
      featureBox.querySelector('h3').textContent = copy[1];
      featureBox.querySelector('p').textContent = copy[2];
    }
  }));
  if (featureClose && featureBox) featureClose.addEventListener('click', () => {
    featureBox.classList.remove('is-visible');
    document.querySelectorAll('[data-db-feature]').forEach((item) => item.classList.remove('is-active'));
  });

  const sticky = document.querySelector('[data-db-sticky]');
  const hero = document.querySelector('[data-db-hero]');
  if (sticky && hero) {
    const mobile = window.matchMedia('(max-width: 700px)');
    let heroVisible = true;
    const update = () => sticky.classList.toggle('is-visible', mobile.matches || !heroVisible);
    if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { heroVisible = entry.isIntersecting; update(); }, { threshold: .12 }).observe(hero);
    mobile.addEventListener('change', update); update();
  }

  selectVariant(root.dataset.variantId);
  buttons.forEach((button) => button.addEventListener('click', async () => {
    const labels = buttons.map((item) => item.innerHTML);
    buttons.forEach((item) => { item.disabled = true; item.textContent = 'Adding…'; });
    statuses.forEach((item) => { item.textContent = ''; });
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(root.dataset.variantId), quantity: 1 }] }) });
      const ok = response.ok;
      if (!ok) throw new Error('Unable to add');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      buttons.forEach((item) => { item.textContent = ok ? 'Added to cart' : 'Try again'; });
      statuses.forEach((item) => { item.textContent = ok ? 'Your boots are in the cart.' : 'That size could not be added. Please choose another size or try again.'; });
    } catch (_) {
      buttons.forEach((item) => { item.textContent = 'Try again'; });
      statuses.forEach((item) => { item.textContent = 'We could not add the boots. Please try again.'; });
    } finally { window.setTimeout(() => buttons.forEach((item, index) => { item.disabled = false; item.innerHTML = labels[index]; }), 1800); }
  }));
})();
